export const KNOWN_DIRECTIONS = ['prelevement', 'injection']